import { useGetOnMount } from 'hooks/useGetOnMount';
import { ACCOUNT_API_EVENT_LOG } from 'apiRoutes';
import { AuditLogTable } from 'components/common/AuditLogTable/AuditLogTable';
import { auditLogTableColumns } from 'components/common/AuditLogTable/auditLogTableColumns';
import { FunctionComponent, useMemo } from 'react';

export const AccountAuditLog: FunctionComponent<{ accountId: string }> = ({
	accountId,
}) => {
	const { data, status } = useGetOnMount(
		`${ACCOUNT_API_EVENT_LOG}/GetEvents?accountId=${accountId}`,
	);

	const columns = useMemo(
		() => [
			auditLogTableColumns.time(),
			auditLogTableColumns.message(),
			auditLogTableColumns.admin(),
			auditLogTableColumns.application(),
			auditLogTableColumns.company(),
			auditLogTableColumns.subscription(),
			auditLogTableColumns.comment(),
		],
		[data],
	);

	return (
		<AuditLogTable requestStatus={status} data={data} columns={columns} />
	);
};
